import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, X } from "@phosphor-icons/react";
import { useSavedLocations } from "../lib/SavedLocationsContext";
import { useAuth } from "../lib/AuthContext";

const SEEN_KEY = "firewatch:tour_prompt_seen";

export default function TourPrompt() {
  const { locations } = useSavedLocations();
  const { user } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(SEEN_KEY)) return;
    if (user || locations.length > 0) {
      localStorage.setItem(SEEN_KEY, "1");
      return;
    }
    const t = setTimeout(() => {
      if (!localStorage.getItem(SEEN_KEY)) setShow(true);
    }, 2500);
    return () => clearTimeout(t);
  }, [user, locations.length]);

  const dismiss = () => {
    localStorage.setItem(SEEN_KEY, "1");
    setShow(false);
  };

  if (!show) return null;
  return (
    <div
      data-testid="tour-prompt"
      className="fixed bottom-16 left-1/2 -translate-x-1/2 z-[1200] w-[calc(100vw-24px)] max-w-md sm:w-auto flex items-center gap-3 px-4 py-3 border border-tac-primary/50 bg-tac-bg/95 backdrop-blur-xl rounded-sm shadow-lg shadow-black/40 animate-in fade-in slide-in-from-bottom-2"
    >
      <BookOpen size={18} weight="fill" className="text-tac-primary shrink-0" />
      <div className="text-[13px] text-tac-text leading-snug">
        <span className="font-bold">New here?</span> Two minutes in the guide and you'll read
        this map like a pro.
      </div>
      <Link
        to="/guide"
        onClick={dismiss}
        data-testid="tour-prompt-cta"
        className="shrink-0 px-3 py-1.5 bg-tac-primary text-black text-[11px] font-bold uppercase tracking-wider rounded-sm hover:opacity-90 transition-opacity"
      >
        Take the tour
      </Link>
      <button
        type="button"
        onClick={dismiss}
        data-testid="tour-prompt-dismiss"
        title="Dismiss"
        className="shrink-0 text-tac-faint hover:text-tac-text transition-colors"
      >
        <X size={14} weight="bold" />
      </button>
    </div>
  );
}
